import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { RouterPathService } from "../../../../core/common/variables/router-path.service";
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslateService } from "../../../common/variables/translate-service";
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ImagePathService } from '../../../common/variables/image-path.service';
import { NgbCarousel } from '@ng-bootstrap/ng-bootstrap';
import { RoofType } from "../../../common/roof/RoofType";
import { MountingSystem } from "../../../common/mountsys/MountingSystem";
import { SC_Input } from "../../../common/input/SC_Input";
import { MountingType } from "../../../common/mountsys/MountingType";
import { BattenDivision } from "../../../common/roof/BattenDivision";
import { Sol50 } from "../../../common/mountsys/Sol50";
import { RoofHookInput } from '../../../common/stocklist/roofhook/RoofHookInput';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmationBoxComponent } from "../../../common/components/confirmation-box/confirmation-box.component";
import { GlobalVariableService } from "../../../common/variables/global-variable";
import { GlobalFunctionService } from "../../../common/services/global-function.service";
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Global } from '../../../common/utilities/global';

declare let html2canvas: any;

@Component({
  selector: 'sen-app-roof-mounting',
  templateUrl: './roof-mounting.component.html',
  styleUrls: ['./roof-mounting.component.scss']
})

export class RoofMountingComponent implements OnInit {
  prevPath: string;
  nextPath: string;
  selectedProject$: Observable<any[]>;
  planName: string;
  planNameExist: boolean = false;
  selectedPlan: any = SC_Input.sPlan;
  prefixRT: string = 'R-';
  prefixMS: string = 'M-';
  prefixST: string = 'S-';
  form: FormGroup;
  //isFlatRoof: boolean = false;
  isOpenWindow: boolean = false;

  @ViewChild('mountSlide') mountSlide: NgbCarousel;
  @ViewChild('roofTypeSlide') roofTypeSlide: NgbCarousel;
  @ViewChild('profileColor') profileColor: NgbCarousel;
  @ViewChild('subTypeSlide') subTypeSlide: NgbCarousel;
  @ViewChild('planNameField') planNameField: ElementRef;

  mountingLableArray = [
    'MOUNTSYS_UNKNOWN',
    'SOL50_PREM_2M',
    'SOL50_STAN_4M',
    'SOL50_PREM_4M',
    'SOL50_PREM_IN',
    'SOL50_STAN_IN',
    'SOL50_BASIS',
    'SOL50_50S',
    'SOL50_50IS',
    'SOL50_STAN_2M',
    'MS_SOLSMART'
  ]
  mountingType = [
    {
      src: this.imagePath.MOUNT_DIRECT,
      label: this.translate.getLng('MOUNT_DIRECT'),
      data: MountingType.DIRECT
    },
    {
      src: this.imagePath.CRISS_CROSS,
      label: this.translate.getLng('CRISS_CROSS'),
      data: MountingType.CRISS_CROSS
    }
  ];

  battenDivision = [
    {
      src: this.imagePath.BATTEN_SPACED,
      label: this.translate.getLng('BATTEN_SPACED'),
      data: BattenDivision.BATTEN
    },
    {
      src: this.imagePath.BATTEN_PLANKING,
      label: this.translate.getLng('BATTEN_PLANKING'),
      data: BattenDivision.PLANKING
    }
  ];

  profileFinish = [
    {
      src: this.imagePath.COLOR_BLACK,
      label: this.translate.getLng('COLOR_BLACK'),
      data: MountingSystem.SOL50_COLOR_SW
    },
    {
      src: this.imagePath.COLOR_PRESSBLANK,
      label: this.translate.getLng('COLOR_PRESSBLANK'),
      data: MountingSystem.SOL50_COLOR_PB
    }
  ];

  roofTypeOnRoof = [
    {
      src: this.imagePath.ROOF_TRAPEZOIDAL,
      label: this.translate.getLng('ROOF_TRAPEZOIDAL'),
      data: RoofType.TRAPEZOIDAL,
      subType: {
        title: this.translate.getLng('MOUNT_TYPE'),
        types: this.mountingType
      }
    },
    {
      src: this.imagePath.ROOF_CORRUGATED,
      label: this.translate.getLng('ROOF_CORRUGATED'),
      data: RoofType.CORRUGATED,
    }
  ];

  roofTypeIntegrated: any = [
    {
      src: this.imagePath.ROOF_PANTILED,
      label: this.translate.getLng('ROOF_PANTILED'),
      data: RoofType.PANTILED
    },
    {
      src: this.imagePath.ROOF_SLATED,
      label: this.translate.getLng('ROOF_SLATED'),
      data: RoofType.SLATED,
    },
    {
      src: this.imagePath.ROOF_PLAIN_TILED,
      label: this.translate.getLng('ROOF_PLAIN_TILED'),
      data: RoofType.PLAIN_TILED
    }
  ];

  allRoofType = [this.roofTypeIntegrated[0], ...this.roofTypeOnRoof, this.roofTypeIntegrated[1], this.roofTypeIntegrated[2]];
  // the following json struchture includes all sub and main roof type slides
  mountingSystem = [
    {
      src: this.imagePath.SOL50_STAN_2M,
      label: this.translate.getLng('SOL50_STAN_2M'),
      data: MountingSystem.SOL50_STAN_2M,
      profile: this.profileFinish[1],
      roofType: this.allRoofType
    },
    {
      src: this.imagePath.SOL50_PREM_2M,
      label: this.translate.getLng('SOL50_PREM_2M'),
      data: MountingSystem.SOL50_PREM_2M,
      profile: this.profileFinish[0],
      roofType: this.allRoofType
    },
    {
      src: this.imagePath.SOL50_STAN,
      label: this.translate.getLng('SOL50_STAN_4M'),
      data: MountingSystem.SOL50_STAN_4M,
      profile: this.profileFinish[1],
      roofType: this.allRoofType
    },
    {
      src: this.imagePath.SOL50_PREM,
      label: this.translate.getLng('SOL50_PREM_4M'),
      data: MountingSystem.SOL50_PREM_4M,
      profile: this.profileFinish[0],
      roofType: this.allRoofType
    },
    {
      src: this.imagePath.SOL50I_PREM,
      label: this.translate.getLng('SOL50_PREM_IN'),
      data: MountingSystem.SOL50_PREM_IN,
      profile: this.profileFinish[0],
      roofType: this.roofTypeIntegrated
    },
  ];

  selectedMountingSystem: any;
  selectedRoofType: any;
  selectedSubRoofType: any;

  constructor(private routerPath: RouterPathService,
    public translate: TranslateService,
    public imagePath: ImagePathService,
    private route: ActivatedRoute,
    public globalF: GlobalFunctionService,
    public dialog: MatDialog,
    public global: GlobalVariableService,
    private formBuilder: FormBuilder,
    public globalFunction: GlobalFunctionService,
    private store: Store<any>,
    private _snackBar: MatSnackBar,
    private router: Router) {
    this.form = this.formBuilder.group({
      planName: new FormControl(null, Validators.required)
    })
    this.prevPath = this.routerPath.MPProjectPath;
    this.nextPath = `..${this.routerPath.pathSeperator}${this.routerPath.RPShapeString}`;
    this.selectedProject$ = this.store.select(state => { return state.appData.selectedProject });
    this.checkIntergrated(SC_Input.iMountSys);
  }

  ngOnInit(): void {
    this.isOpenWindow = true;
  }

  checkIntergrated(mSys: number) {//for integrated batter is not available
    if (mSys != MountingSystem.SOL50_PREM_IN) {
      this.roofTypeIntegrated[1].subType = {
        title: this.translate.getLng('BATTEN_DIVISION'),
        types: this.battenDivision
      };
    } else {
      delete this.roofTypeIntegrated[1].subType;
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.planNameField.nativeElement.focus();
    }, 0);
  }

  ngAfterContentInit() {
    this.fetchInput();
  }

  checkPlanExistName(event: any) {
    this.planNameExist = this.globalFunction.checkRoofPlayNameExist(event.target.value.toLowerCase());
  }

  mountSlideDone(event: any, roofType: NgbCarousel) {
    this.selectedMountingSystem = this.mountingSystem[event.current.split('-').pop()];
    this.checkIntergrated(this.selectedMountingSystem.data);
    this.selectedRoofType = this.mountingSystem[0].roofType[0];
    //when mounting system changes resets rooftype
    roofType.select(this.prefixRT + '0');
    SC_Input.isPlanAltered = true;
  }

  //the pop function used to retrive the index of the selected item
  roofTypeSlideDone(event: any) {
    this.selectedRoofType = this.selectedMountingSystem.roofType[event.current.split('-').pop()];
    this.selectedSubRoofType = this.selectedRoofType.subType ? this.selectedRoofType.subType.types[0] : null;
    SC_Input.isPlanAltered = true;
  }

  subTypeSlideDone(event: any) {
    this.selectedSubRoofType = this.selectedRoofType.subType!.types[event.current.split('-').pop()];
    SC_Input.isPlanAltered = true;
  }

  private fetchInput() {
    // preselect slides when edit plan for new plan index will be 0
    let ms = this.mountingSystem.findIndex(i => i.data == SC_Input.iMountSys);
    if (ms < 0) {
      if (typeof SC_Input.iMountSys != 'undefined') {
        this.triggerAlertBox();
      }
      ms = 0;
    }
    this.selectedMountingSystem = this.mountingSystem[ms];
    this.selectedPlan ? this.form.get('planName')?.setValue(this.selectedPlan.name) : this.form.get('planName')?.setValue(SC_Input.sName);
    //set time out used to wait untill slide navigation complete
    setTimeout(() => {
      this.mountSlide.select(this.prefixMS + ms);
      let rt = this.selectedMountingSystem.roofType.findIndex((t: any) => t.data == SC_Input.iRoofType);
      this.selectedRoofType = this.selectedMountingSystem.roofType[rt];
      this.roofTypeSlide.select(this.prefixRT + rt);
      if (this.selectedRoofType.subType) {
        setTimeout(() => {
          let st;
          if (SC_Input.iBattenDivision) {
            st = this.selectedRoofType.subType.types.findIndex((s: any) => s.data == SC_Input.iBattenDivision);
          } else if (SC_Input.iMountingType) {
            st = this.selectedRoofType.subType.types.findIndex((s: any) => s.data == SC_Input.iMountingType);
          }
          this.selectedSubRoofType = this.selectedRoofType.subType.types[st];
          this.subTypeSlide.select(this.prefixST + st);
          setTimeout(() => {
            SC_Input.isPlanAltered = false;
          }, 0)
        }, 0);
      }
    }, 0);
  }

  private rememberInput(): void {
    if (SC_Input.iRoofType != this.selectedRoofType.data || SC_Input.iMountSys != this.selectedMountingSystem.data) {
      SC_Input.clearRoof();
      SC_Input.updatedBeamInput = false;
      Global.panelRows = [];
      Global.roofObstructions = [];
      if (SC_Input.sPlanDetails?.panelRows?.length > 0) {
        SC_Input.sPlanDetails.panelRows = [];
        SC_Input.sPlanDetails.roofObstructions = [];
      }
    }
    // SC_Input.sCountry = "DE"; //needs to be get from api
    SC_Input.iRoofType = this.selectedRoofType.data;
    if (SC_Input.iMountSys != this.selectedMountingSystem.data) {
      SC_Input.iMountSys = this.selectedMountingSystem.data;
      SC_Input.roofhookinputCurrent = new RoofHookInput();;
      SC_Input.sHProfile = "";
    }
    SC_Input.iFrameColor = this.selectedMountingSystem.profile.data;
    if (SC_Input.sName != this.form.get('planName')?.value) {
      SC_Input.isPlanAltered = true;
    }
    SC_Input.sName = this.form.get('planName')?.value;
    if (MountingSystem.isInRoof(this.selectedMountingSystem.data)) {
      //in-roof
      SC_Input.bInRoof = true;
      Sol50.nHorizontalAbstand = 0.7;
      SC_Input.bBeam = false;
    } else {
      //on-roof
      SC_Input.bInRoof = false;
      Sol50.nHorizontalAbstand = 0.7;
      SC_Input.bBeam = true;
      //initialize batten division
      SC_Input.iBattenDivision = BattenDivision.NONE;
      //initialize mounting type
      SC_Input.iMountingType = MountingType.NONE;
      if (SC_Input.iRoofType == RoofType.SLATED) {
        SC_Input.iBattenDivision = this.selectedSubRoofType.data;
      } else if (SC_Input.iRoofType == RoofType.TRAPEZOIDAL) {
        SC_Input.iMountingType = this.selectedSubRoofType.data;
        if (SC_Input.iMountingType == MountingType.DIRECT) {
          SC_Input.bBeam = false;
        }
      }
    }
  }

  // for swipe in touch devices
  onSwipeCarousel(event: any, carousel: NgbCarousel) {
    SC_Input.isPlanAltered = true;
    if (event.type == "swiperight") {
      carousel.next()
    } else {
      carousel.prev();
    }
  }

  triggerAlertBox() {
    let message = this.translate.getLng('UNSUPPORT_MOUNT_TYPE').replace('(MOUNT_TYPE)', this.mountingLableArray[SC_Input.iMountSys])
    let dialogRef = this.globalF.openAlertBox(message, this.translate.getLng('OK'));
    dialogRef.afterClosed().subscribe((color: string) => {
      dialogRef.close();
    });
  }

  triggerConfirmation() {
    let dialogRef = this.globalF.openConfirmationBox('UNSUBMITTED_DATA_MESSAGE', 'CONFIRM_LEAVE', 'CONFIRM_STAY');
    dialogRef.afterClosed().subscribe((result: boolean) => {
      dialogRef.close();
      if (result) {
        SC_Input.isPlanAltered = false;
        this.router.navigate([this.prevPath], {
          state: { action: this.global.savePlan }
        });
      }
    });
  }

  navPrev() {
    if (SC_Input.isPlanAltered) {
      this.triggerConfirmation();
    } else {
      this.router.navigate([this.prevPath]);
    }
  }

  navNext() {
    this.isOpenWindow = false;
    setTimeout(() => {
      html2canvas(document.querySelector("#google_map_modal_id"),{ useCORS : true }).then((canvas: any) => {
        Global.googleMapImage = canvas.toDataURL();

     });

     this.isOpenWindow = true;
      this.form.markAllAsTouched();
      if (this.form.invalid || this.planNameExist) {
        return;
      }
      this.rememberInput();
      this.router.navigate([this.nextPath], { relativeTo: this.route });
    }, 100);

  }

  //flat roof check
  //isFlatRoofEnabled(event: any){
    //console.log('event',event);
   // console.log('SC_Input.isFlatRoofType 0',this.isFlatRoof);
    //this.isFlatRoof = !this.isFlatRoof;
  //  SC_Input.isFlatRoofType = this.isFlatRoof;
  //  console.log('SC_Input.isFlatRoofType 1',SC_Input.isFlatRoofType);
  //}
}

